var fonts = {
    matter: "Matter, Arial, sans-serif",
};

export { fonts as default };
//# sourceMappingURL=fonts.js.map
